const actions = {
  INIT ({ commit, firebase }) {}
}

export default actions
